var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCensusDataSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 399,
    width: 16,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-163 -399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 12.3438 12.0312 2.96875C12.0312 2.05531 9.69672 1.5625 7.5 1.5625 5.30328 1.5625 2.96875 2.05531 2.96875 2.96875L2.96875 12.3438C2.96875 13.2572 5.30328 13.75 7.5 13.75 9.69672 13.75 12.0312 13.2572 12.0312 12.3438ZM7.5 1.875C9.91453 1.875 11.7188 2.45312 11.7188 2.96875 11.7188 3.48438 9.91453 4.0625 7.5 4.0625 5.08547 4.0625 3.28125 3.48438 3.28125 2.96875 3.28125 2.45312 5.08547 1.875 7.5 1.875ZM3.28125 3.50937C3.98891 4.075 5.78641 4.375 7.5 4.375 9.21359 4.375 11.0111 4.075 11.7188 3.50937L11.7188 6.09375C11.7188 6.60938 9.91453 7.1875 7.5 7.1875 5.08547 7.1875 3.28125 6.60938 3.28125 6.09375ZM3.28125 6.63437C3.98891 7.2 5.78641 7.5 7.5 7.5 9.21359 7.5 11.0111 7.2 11.7188 6.63437L11.7188 9.21875C11.7188 9.73438 9.91453 10.3125 7.5 10.3125 5.08547 10.3125 3.28125 9.73438 3.28125 9.21875ZM3.28125 12.3438 3.28125 9.75937C3.98891 10.325 5.78641 10.625 7.5 10.625 9.21359 10.625 11.0111 10.325 11.7188 9.75937L11.7188 12.3438C11.7188 12.8594 9.91453 13.4375 7.5 13.4375 5.08547 13.4375 3.28125 12.8594 3.28125 12.3438Z",
    transform: "matrix(1.06667 0 0 1 163 399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 5.625C10.9375 5.79759 10.7976 5.9375 10.625 5.9375 10.4524 5.9375 10.3125 5.79759 10.3125 5.625 10.3125 5.45241 10.4524 5.3125 10.625 5.3125 10.7976 5.3125 10.9375 5.45241 10.9375 5.625Z",
    transform: "matrix(1.06667 0 0 1 163 399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 8.75C10.9375 8.92259 10.7976 9.0625 10.625 9.0625 10.4524 9.0625 10.3125 8.92259 10.3125 8.75 10.3125 8.57741 10.4524 8.4375 10.625 8.4375 10.7976 8.4375 10.9375 8.57741 10.9375 8.75Z",
    transform: "matrix(1.06667 0 0 1 163 399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 11.875C10.9375 12.0476 10.7976 12.1875 10.625 12.1875 10.4524 12.1875 10.3125 12.0476 10.3125 11.875 10.3125 11.7024 10.4524 11.5625 10.625 11.5625 10.7976 11.5625 10.9375 11.7024 10.9375 11.875Z",
    transform: "matrix(1.06667 0 0 1 163 399)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensusDataSource);
export default __webpack_public_path__ + "static/media/CensusDataSource.148b22475a4267cb9907f222c41abc5d.svg";
export { ForwardRef as ReactComponent };